"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const extractMathRx = /^\s*<html>\s*<script\s*type="math\/tex(?:;[^"]*)">([\s\S]*)<\/script><\/html>\s*$/;
const htmlRenderer = (opts) => {
    const { elementCreator: el, mathRenderer: renderMath } = opts;
    return (data) => {
        var _a;
        const math = ((_a = extractMathRx.exec(data)) !== null && _a !== void 0 ? _a : [])[1];
        return math
            ? el('div', ['latex-output'], renderMath(math))
            : el('div', ['html-output'], data);
    };
};
/**
 * Returns a text/html data renderer with workaround for SageMath (La)TeX output.
 */
exports.default = htmlRenderer;
//# sourceMappingURL=htmlRenderer.js.map